export enum PackagesActionTypes {
  GET_LIST_PACKAGES_SUCCESS = "PACKAGES_GET_LIST_SUCCESS",
  GET_LIST_PACKAGES_ERROR = "PACKAGES_GET_LIST_ERROR",
  GET_LIST_PACKAGES = "PACKAGES_GET_LIST",
  CREATE_PACKAGE = "CREATE_PACKAGE",
  CREATE_PACKAGE_SUCCESS = "CREATE_PACKAGE_SUCCESS",
  CREATE_PACKAGE_ERROR = "CREATE_PACKAGE_ERROR",
  GET_PACKAGE = "GET_PACKAGE",
  GET_PACKAGE_SUCCESS = "GET_PACKAGE_SUCCESS",
  GET_PACKAGE_ERROR = "GET_PACKAGE_ERROR",
  UPDATE_PACKAGE = "UPDATE_PACKAGE",
  UPDATE_PACKAGE_SUCCESS = "UPDATE_PACKAGE_SUCCESS",
  UPDATE_PACKAGE_ERROR = "UPDATE_PACKAGE_ERROR",
  DELETE_PACKAGE = "DELETE_PACKAGE",
  DELETE_PACKAGE_SUCCESS = "DELETE_PACKAGE_SUCCESS",
  DELETE_PACKAGE_ERROR = "DELETE_PACKAGE_ERROR",
}
